var wellKnownSymbol = require('../internals/well-known-symbol');

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/to-string-tag-support.js
// module id = 351
// module chunks = 1